import { createContext } from "react";

const AppContext = createContext<Record<string, any>>({
    currentNav: true,
    showPopup: true,
    isHamburgerMenuOpen: true
});

export default AppContext;
